import React from "react";
import { useSelector } from "react-redux";
import TableWithCustomSearch from "../../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";

const CrossClubRankingTable = () => {
  const {
    data = [],
    colHeaders = [],
    columns,
    raw_data_link,
    links
  } = useSelector((state) => state.memberVisits.tableInfo);

  return (
    <TableWithCustomSearch
      fileName="cross-club-ranking"
      data={data}
      hideFirstCol
      rawDataLink={raw_data_link}
      colHeaders={colHeaders}
      columns={columns}
      links={links}
    />
  );
};

export default CrossClubRankingTable;
